<app-dialog-wrapper>
  <div class="content">
    @if (showPrimaryToggle) {
      <div class="content__checkbox">
        <app-checkbox
          [label]="primaryLabel"
          [formControl]="isDefaultControl"
        ></app-checkbox>
      </div>
    }

    <div class="address-control">
      <span class="address-control__label">Address</span>
      <app-input-address
        [(ngModel)]="selectedAddress"
        [checkDelivery]="checkDelivery"
      />
    </div>
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button
      [size]="ButtonSize.Large"
      [disabled]="!selectedAddress()"
      (buttonClick)="onSubmit()"
    >
      Save Address
    </app-button>
  </div>
</app-dialog-wrapper>
